var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.items),function(item){return [_vm._v(" "+_vm._s(item.quantity)+" X "+_vm._s(item.paymentToken.name)+" ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }